if ( objects.is_onepage ) {
    var offset_top = 150;

    $('main > section:first-child').addClass('active');

    $('.navbar-head .navbar ul li.onepage a').click(function(e) {
        e.preventDefault();

        var url = $(this).attr("href").split('/').reverse()[1];
        if ( $("#" + url) ) {
            $('html, body').animate({scrollTop: $("#" + url).offset().top - offset_top }, "slow");
        } else {
            gotop();
        }
    });

    var current_url = location.href.split('/').reverse()[1];
    if ( current_url.length > 0 && location.href != objects.url_home + '/') {
        $('html, body').animate({scrollTop: $("#" + current_url).offset().top - offset_top }, "slow");
    } else {
        gotop();
    }

    $(window).on('scroll', function() {
        var scrollTop = $(this).scrollTop();
        var current_id = null;

        if (scrollTop > 0) {
            // Down
            $('main > section').each(function(index) {
                var topDistance = $(this).offset().top;
                if ( (topDistance - (offset_top + 1)) < scrollTop ) {
                    current_id = $(this).attr('id');
                }
            });
        } else if (scrollTop < 0) {
            // Up
            $('main > section').each(function(index) {
                var topDistance = $(this).offset().top;
                if ( (topDistance - (offset_top + 1)) < scrollTop ) {
                    current_id = $(this).attr('id');
                }
            });
        } else {
            //window.history.pushState(null, null, objects.url_home + "/");
            $('.nav-item:first-child').addClass("active");
            $('main > section:first-child').addClass("active");
        }

        if ( current_id != null ) {
            //window.history.pushState(null, null, objects.url_home + "/" + current_id + "/");
            set_nabvar_active(current_id);
        }
    });

    //if ($(window).width() > 1023 && $(window).height() > 919) { }
    // window.addEventListener('mousewheel', function(e) {
    //     e.preventDefault();
    //     var wDelta = e.wheelDelta;
    //     var nextSection = null;

    //     if ( Math.abs(wDelta) > 100 ) {
    //         clearTimeout($.data(this, 'timer'));

    //         $.data(this, 'timer', setTimeout(function() {
    //             if (wDelta < 0) {
    //                 nextSection = $('main .active').next().attr('id');

    //                 if (nextSection) {
    //                     $('html, body').animate({scrollTop: $("#" + nextSection).offset().top - offset_top }, "slow");
    //                 } else {
    //                     $('html, body').animate({scrollTop: $('footer').offset().top - offset_top }, "slow");
    //                 }
    //             } else {
    //                 nextSection = $('main .active').prev().attr('id');
    //                 if (nextSection) {
    //                     $('html, body').animate({scrollTop: $("#" + nextSection).offset().top - offset_top }, "slow");
    //                 } else {
    //                     $('html, body').animate({scrollTop: $('main > section:last-child').offset().top - offset_top }, "slow");
    //                 }
    //             }
    //         }, 100));
    //     }
    // });

    function set_nabvar_active(id) {
        $('.navbar-head .navbar ul li, .navbar-head .navbar ul li a').each(function() {
            $(this).removeClass("active");
        });

        $('main > section').each(function() {
            $(this).removeClass("active");
        });

        $('.navbar-head .navbar ul li.onepage a').each(function() {
            if ( $(this).attr("href").split('/').reverse()[1] === id ) {
                $(this).parent().addClass("active");
                $(this).addClass("active");
            }
        });

        $("#" + id).addClass("active");
    }
}
